export default __webpack_public_path__ + "static/media/Flag_of_United_States.262c6f5c.svg";